export enum LoadingState {
    LOADING,
    LOADED,
    ERROR
}